import { Instagram, Facebook, Linkedin } from "lucide-react";
import { BRAND } from "@/data/content";
import useSettings from "@/hooks/useSettings";
import { useLanguage, withLocalePrefix } from "@/context/LanguageContext";

export default function Footer() {
    const settings = useSettings();
    const { locale } = useLanguage();
    const contact = settings.contact || {};
    const socials = settings.socials || {};
    return (
        <footer
            data-testid="footer"
            className="bg-[#0a1424] text-white/80 pt-20 pb-10"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
                    <div className="md:col-span-5">
                        <img
                            src={BRAND.logo}
                            alt="Logo L'Atelier du meuble by RO Concept"
                            className="h-28 w-auto mb-6 brightness-0 invert opacity-90"
                        />
                        <p className="text-white/55 max-w-sm leading-relaxed text-sm">
                            Studio d'aménagement intérieur et mobilier sur mesure
                            basé à Etterbeek, Bruxelles. Un savoir-faire artisanal
                            au service d'une architecture intérieure raffinée.
                        </p>
                    </div>

                    <div className="md:col-span-2 md:col-start-7">
                        <div className="overline text-white/45 mb-4">Studio</div>
                        <ul className="space-y-2 text-sm">
                            <li><a href={`${withLocalePrefix("/", locale)}#expertise`} className="link-underline">Expertise</a></li>
                            <li><a href={`${withLocalePrefix("/", locale)}#realisations`} className="link-underline">Réalisations</a></li>
                            <li><a href={`${withLocalePrefix("/", locale)}#pourquoi`} className="link-underline">Notre approche</a></li>
                            <li><a href={`${withLocalePrefix("/", locale)}#process`} className="link-underline">Process</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="overline text-white/45 mb-4">Contact</div>
                        <ul className="space-y-2 text-sm">
                            <li>{contact.address}</li>
                            <li><a href={`tel:${(contact.phone || "").replace(/\s/g, "")}`} className="link-underline">{contact.phone}</a></li>
                            <li><a href={`mailto:${contact.email}`} className="link-underline">{contact.email}</a></li>
                            <li className="text-white/45">{contact.hours}</li>
                        </ul>
                    </div>

                    <div className="md:col-span-3 md:col-start-11 flex md:justify-end items-start">
                        <div className="flex gap-3">
                            {socials.instagram && (
                                <a href={socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="social-instagram" className="w-11 h-11 border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#0a1424] transition-colors">
                                    <Instagram size={18} strokeWidth={1.4} />
                                </a>
                            )}
                            {socials.facebook && (
                                <a href={socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="social-facebook" className="w-11 h-11 border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#0a1424] transition-colors">
                                    <Facebook size={18} strokeWidth={1.4} />
                                </a>
                            )}
                            {socials.linkedin && (
                                <a href={socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="social-linkedin" className="w-11 h-11 border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#0a1424] transition-colors">
                                    <Linkedin size={18} strokeWidth={1.4} />
                                </a>
                            )}
                        </div>
                    </div>
                </div>

                <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
                    <div>© {new Date().getFullYear()} L'Atelier du meuble by RO Concept — Tous droits réservés.</div>
                    <div className="flex gap-6">
                        <a href="#" className="link-underline">Mentions légales</a>
                        <a href="#" className="link-underline">Politique de confidentialité</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
